/**
 * Where the dashboard SPA lives. Used to build shareable invite-code links
 * pointing at /signup. Falls back to window.location for resilience if a
 * future build lacks the env var.
 */
export const DASHBOARD_BASE_URL =
  (import.meta.env.VITE_DASHBOARD_URL as string | undefined) ??
  (typeof window !== 'undefined' ? window.location.origin : 'https://link.adhoc.space');
